<template>
  <div>
    <div styleName="opt_player" v-if="isShowVideo" :data-role="cameraStatus" :data-switch="cssStyle">
      <div id="video"></div>
    </div>
    <div styleName="opt_player_loading" v-if="isLoading" :data-switch="cssStyle">
      <div styleName="opt_player_loading_inner">
        <span styleName="opt_player_loading_img"></span>
        <span styleName="opt_player_loading_text">{{ $t('pageLoading') }}</span>
      </div>
    </div>
    <div styleName="opt_player_close" v-if="!cameraStatus" :data-switch="cssStyle">
      <div styleName="opt_player_close_inner">
        <span styleName="opt_player_close_img"></span>
        <span styleName="opt_player_close_text_t">{{ $t('notStartLive') }}</span>
        <span styleName="opt_player_close_text_b">{{ $t('leftVideoToOpen') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import CSSModules from 'vue-css-modules'
import styles from './index.scss'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { mediaSDK, signalSdk } from '@/utils/getSDK'
import sensorLog from '@/utils/sensorLog'
import * as types from '../../constants'
let lastGet = 0
let lastLost = 0
let lostRate = 0
let micVolume = 20

export default {
  name: 'customVideo',
  mixins: [CSSModules(styles)],
  data: function () {
    return {
      isShowVideo: false,
      isLoading: true,
      videoElem: null,
      audioElem: null,
      defaultOptions: {},
    }
  },
  computed: {
    ...mapGetters(['enterMediaRoom', 'roomDetail', 'deviceLists', 'cameraStatus', 'audioStatus', 'isPlayingVideo', 'currentVideoUrl', 'cssStyle', 'hasPublished']),
    selectedDevice () {
      return this.$store.state.mediaInfo.selectedDevice
    },
    usedVideoId () {
      return this.deviceLists.videoList && this.deviceLists.videoList[this.selectedDevice.video].deviceId || ''
    },
    usedAudioId () {
      return this.deviceLists.audioList && this.deviceLists.audioList[this.selectedDevice.audio].deviceId || ''
    },
    isMixClose () {
      return this.$store.state.audioInfo.isMixClose
    }
  },
  watch: {
    enterMediaRoom: function (newData) {
      let { status } = newData.data
      if (status === 1) {
        this.fetchDeviceList().then(() => {
          if (this.cameraStatus) {
            // 视频打开的时候切换设备
            this.initPlay({
              audio: true,
              video: true
            })
          }
        }).catch((error) => {
          sensorLog.track("fetchDeviceList", types.SENSORLOG.type.FAILED, error)
          this.$toast.show({
            text: error,
            headerDesc: this.$t('attention'),
            buttonCount: 1,
            textStyle: {
              textAlign: 'center'
            },
            btnText: this.$t('btnok'),
            btnOK: () => {
              window.location.reload()
            }
          })
        })
      }
    },
    cameraStatus: function (newData) {
      if (newData) {
        signalSdk.sendOpenVideoMessage()
        // 控制视频窗口的打开关闭
        this.$emit('toggle', true)
      } else {
        signalSdk.sendCloseVideoMessage()
        this.$emit('toggle', false)
      }
      sensorLog.track("toggle_camera_status", types.SENSORLOG.type.SUCCESSED, newData)
      // 视频切换导致的流重建，都会含有音频流，音频是否播放，通过enableAudie/disableAudio控制
      this.changeStream(newData, true)
    },
    audioStatus: function (newData) {
      // 如果当前有流 开关流 如果没有 新建流
      let steam = mediaSDK.getLocalStream()
      if (steam) {
        if (newData) {
          mediaSDK.enableAudio()
        } else {
          mediaSDK.disableAudio()
        }
      }
      sensorLog.track("toggle_audio_status", types.SENSORLOG.type.SUCCESSED, newData)
    },
    // 切换设备，直接换掉流，手动发布，不需要自己重新发布
    // selectedDevice: {
    //   handler: async function () {
    //     let { video, audio } = this.localStream
    //     await this.changeStream(video, audio)
    //   },
    //   deep: true
    // },
    // '$store.state.audioInfo.isMixClose': async function () {
    //   let { video, audio } = this.localStream
    //   await this.changeStream(video, audio)
    // },
    // '$store.state.mediaInfo.startGetLostRate': async function (val) {
    //   if (val) {
    //     this.$store.dispatch('modifyLostRate', await this.getNetStats())
    //     this.lostRateInterval = setInterval(async () => {
    //       this.$store.dispatch('modifyLostRate', await this.getNetStats())
    //     }, 5000)
    //   }
    // }
  },
  mounted () {
    // 监听恢复混音事件
    this.$eventSource.addListener('RESUME_STREAM', () => {
      this.audioElem = null
      this.videoElem = null
      this.disconnectMediaElement()
      sensorLog.track("resume_stream_listener", types.SENSORLOG.type.SUCCESSED)
    })
    // 视频加载后判断是否需要进行混音操作
    this.$eventSource.addListener('VIDEO_MOUNTED', async (elem) => {
      this.videoElem = elem
      let steam = mediaSDK.getLocalStream()
      if (this.videoElem &&
        this.isPlayingVideo === 2 &&
        steam) {
        console.log('video mixed mounted replaceTrack======', elem)
        this.connectMediaElement(this.$audioMixing, this.videoElem, true)
        sensorLog.track("video_mixing_listener", types.SENSORLOG.type.SUCCESSED, true)
      }
    })
    // 音频加载后判断是否需要进行混音操作
    this.$eventSource.addListener('AUDIO_MOUNTED', elem => {
      this.audioElem = elem
      let steam = mediaSDK.getLocalStream()
      console.log(`%c [${this.audioElem}]`, "color: orange;font-weight:bold;font-size:50px", this.audioElem)
      console.log(`%c [${this.isPlayingVideo}]`, "color: red;font-weight:bold;font-size:50px", this.isPlayingVideo !== 2)
      console.log(`%c [stream]`, "color: blue;font-weight:bold;font-size:50px", steam)
      if (this.audioElem &&
        this.isPlayingVideo !== 2 &&
        steam) {
        this.connectMediaElement(this.$audioMixing, this.audioElem, true, micVolume)
        sensorLog.track("audio_mixing_listener", types.SENSORLOG.type.SUCCESSED, true)
      }
    })
    mediaSDK.on('STREAM_PUBLISHED', () => {
      console.log('老师监听到发布流')
      this.OPERATE_STREAM(true)
      this.mixMedia()
    })
    mediaSDK.on('STREAM_UNPUBLISHED', () => {
      console.log('老师监听到取消发布流')
      this.OPERATE_STREAM(false)
      this.$store.commit(types.MEDIA_CAMERA_STATUS, false)
    })

  },
  methods: {
    ...mapActions([
      'fetchDeviceList',
    ]),
    ...mapMutations([
      'MEDIA_CAMERA_STATUS',
      'OPERATE_STREAM'
    ]),
    initPlay (options) {
      let { userId } = this.roomDetail.data
      this.isShowVideo = true
      this.isLoading = true
      let init = async () => {
        let { cameraId, microphoneId } = {
          cameraId: this.usedVideoId,
          microphoneId: this.usedAudioId
        }
        this.defaultOptions = {
          userid: userId,
          video: options.video || false,
          audio: options.audio === undefined ? true : options.audio,
          screen: false,
          cameraId: cameraId,
          microphoneId: microphoneId,
          mirror: false
        }
        console.log('=====cameraId======', cameraId)
        // 创建音频视频对象(constraints)
        try {
          this.localStream = await mediaSDK.getMedialStream(this.defaultOptions)
          //  = mediaSDK.getLocalStream()
        } catch (e) {
          sensorLog.track("getMedialStream", types.SENSORLOG.type.FAILED, e)
          this.$toast.show({
            header: false,
            text: this.$t('NotAllowedTip'),
            textStyle: {
              'text-align': 'center'
            },
            btnText: this.$t('refresh'),
            btnOK: () => {
              location.reload()
            }
          })
          sensorLog.track("player_get_media_stream", types.SENSORLOG.type.FAILED, JSON.stringify(e))
          return
        }
        await this.mixStream()
        this.isLoading = false

        try {
          mediaSDK.playMedial({ videoId: 'video' })
        } catch (err) {
          sensorLog.track("playMedial", types.SENSORLOG.type.FAILED, err)
          this.$toast.show({
            text: err,
            headerDesc: this.$t('attention'),
            buttonCount: 1,
            textStyle: {
              textAlign: 'center'
            },
            btnText: this.$t('btnok'),
            btnOK: () => {
              window.location.reload()
            }
          })
        }
        mediaSDK.publishMedialStream().catch((err) => {
          sensorLog.track("publishMedialStream", types.SENSORLOG.type.FAILED, err)
          this.$toast.show({
            text: 'video error,please try again!',
            headerDesc: this.$t('attention'),
            buttonCount: 1,
            textStyle: {
              textAlign: 'center'
            },
            btnText: this.$t('btnok'),
            btnOK: () => {
              window.location.reload()
            }
          })
        })
        if (!this.audioStatus) {
          mediaSDK.disableAudio()
        }
        sensorLog.track("media_control_status", types.SENSORLOG.type.SUCCESSED, JSON.stringify({ video: options.video, audio: this.audioStatus, mix: this.isMixClose ? 'close' : 'open' }))
      }
      let initDom = async () => {

        if (this.hasPublished) {
          // 流已经发布，不可以再发
          // console.log('============this.hasPublished===========', this.hasPublished)
          return false
        }
        await init()
        document.getElementById('video').style.height = '100%'
      }
      this.$nextTick(initDom)
    },
    async changeStream (video, audio) {
      if (video) {
        this.initPlay({
          video,
          audio
        })
      } else {
        let steam = mediaSDK.getLocalStream()
        console.log('===========this.hasPublish====', this.hasPublished)
        if (steam && this.hasPublished) {
          try {
            await mediaSDK.unpublishMedialStream()
            await mediaSDK.closeMedial()
          } catch (error) {
            sensorLog.track("unpublishMedialStream", types.SENSORLOG.type.FAILED, error)
            this.$toast.show({
              text: 'video error,please try again!',
              headerDesc: this.$t('attention'),
              buttonCount: 1,
              textStyle: {
                textAlign: 'center'
              },
              btnText: this.$t('btnok'),
              btnOK: () => {
                window.location.reload()
              }
            })
          }

        }
        this.isShowVideo = false
      }
    },
    async mixStream () {
      if (!this.isMixClose) {
        this.$audioMixing.confluence(this.localStream)
      }
      console.log(`current mixing status: ${this.isMixClose ? 'close' : 'open'} `)
    },
    // 关闭视频后需要恢复混音
    async disconnectMediaElement () {
      this.$audioMixing.disconnectMediaElementFromDest()
      this.$audioMixing.resumeDefaultVolume()
    },
    // 新流发布之后根据环境判断是否需要进行混音
    mixMedia () {
      console.log('========stream published=============')
      sensorLog.track("new_stream_mixing_listener", types.SENSORLOG.type.SUCCESSED)
      if (this.videoElem && this.isPlayingVideo === 2) {
        this.connectMediaElement(this.$audioMixing, this.videoElem)
      }
      if (this.audioElem && this.isPlayingVideo !== 2) {
        this.connectMediaElement(this.$audioMixing, this.audioElem)
      }
    },
    /**
     *
     * @param mixing 混音实例
     * @param elem 混音对应的audio或video元素
     * @param isConnectMediaElement 是否需要重新进行audio或video元素标签连接(销毁重建的话需要重新连接)
     * @param volume 控制混音中麦克风的音量
     */
    connectMediaElement (mixing, elem, isConnectMediaElement, volume) {
      console.log(']]]]]]]]]]]this.isMixClose]]]]]]]]]]]]]]]]]]]]]]]]]', this.isMixClose)
      if (this.isMixClose) return
      // 将需要进行混音音频源连接到混音destination上
      mixing.connectMediaElementToDest(elem, isConnectMediaElement)
      if (volume) mixing.setMicroVolume(volume)
    },
    getNetStats () {
      return mediaSDK.getStreamStats().then((stats) => {
        let get, lost
        get = Number(stats.videoSendPackets)
        lost = Number(stats.videoSendPacketsLost)
        if (get !== 0) {
          lostRate = (lost - lastLost) / ((get - lastGet) + (lost - lastLost))
        }
        lastGet = get
        lastLost = lost
        return lostRate + this.getRandom()
      })
        .catch((err) => {
          sensorLog.track("media_get_stream_stats", types.SENSORLOG.type.FAILED, err)
        })
    },
    getRandom () {
      return Math.random() / 2000
    }
  }
}
</script>
